import React from 'react';
import { Card, Text, Badge, ActionIcon, Stack, Flex } from '@mantine/core';

const TaskCard = ({ task, index, onTaskClick }) => {
    const handleCardClick = () => {
        if (onTaskClick) {
            onTaskClick(task);
        }
    };

    return (
        <Card
            onClick={handleCardClick}
            shadow="sm"
            padding="sm"
            radius="md"
            withBorder
            style={{
                cursor: 'pointer',
                backgroundColor: 'white',
            }}
        >
            <Stack spacing="xs">
                <Flex justify="space-between" align="flex-start">
                    <Text weight={500} size="sm" lineClamp={2}>
                        {task.title}
                    </Text>
                </Flex>
                
                <Text size="xs" color="dimmed" lineClamp={3}>
                    {task.summary || 'Sin descripción'}
                </Text>
                
                <Flex justify="space-between" align="center">
                    <Text size="xs" color="dimmed">
                        {task.start ? new Date(task.start).toLocaleDateString('es-ES') : 'Sin fecha'}
                    </Text>
                    
                    <Badge 
                        size="xs" 
                        style={{
                            backgroundColor: task.activity_priority?.bgcolor || '#gray',
                            color: task.activity_priority?.txcolor || '#white'
                        }}
                        variant="filled"
                    >
                        {task.activity_priority?.name || 'Sin prioridad'}
                    </Badge>
                </Flex>
                
                {task.activity_group && (
                    <Badge 
                        size="xs" 
                        style={{
                            backgroundColor: task.activity_group?.bgcolor || '#gray',
                            color: task.activity_group?.txcolor || '#white'
                        }}
                        variant="filled"
                        fullWidth
                    >
                        <i className={task.activity_group?.icon || 'icon-circle'}></i> {task.activity_group?.name}
                    </Badge>
                )}
            </Stack>
        </Card>
    );
};

export default TaskCard;